import i18next from "i18next";

import { WORKER_TYPES } from "../filters/constants";

export const getFilteredWorkers = (
	allWorkers: any[],
	appliedFilters: any[]
) => {
	let filteredWorkers = [...allWorkers];
	if (appliedFilters.length > 0) {
		filteredWorkers = filteredWorkers.filter((item: any) => {
			return appliedFilters.every((filter) => {
				switch (filter?.type) {
					case "Work Center":
						return filter?.data?.some(
							(workCenter: any) => workCenter?.id === item?.workCenterId
						);
					case "Reporting Manager":
						return filter?.data?.some(
							(manager: any) => manager?.id === item?.managerUserId
						);
					case "Worker Status":
						return filter?.data?.some(
							(workerStatus: any) => workerStatus?.id === item?.workerStatusId
						);
					case WORKER_TYPES: {
						// Get all the selected IDs
						const selectedIds = filter.data.map(({ id }: { id: string }) =>
							Number(id)
						);
						const workerTypeId = Number(item.workerTypeId);
						const workerSubTypeId = item.workerSubTypeId
							? Number(item.workerSubTypeId) + 1000
							: null;

						// Early return if parent type not selected
						if (!selectedIds.includes(workerTypeId)) return false;

						// If no subtypes selected, show all items with parent type
						if (!selectedIds.some((id: number) => id >= 1000)) return true;

						// If subtypes selected, must match specific subtype
						return workerSubTypeId
							? selectedIds.includes(workerSubTypeId)
							: false;
					}
					default:
						return true;
				}
			});
		});
	}

	return filteredWorkers;
};

export const statusColors = {
	SCH: {
		code: "SCH",
		name: "Scheduled",
		backgroundColor: "#EEEEEE",
		textColor: "#000000",
		borderColor: "#EEEEEE",
	},
	RAS: {
		code: "RAS",
		name: "Reassigned",
		backgroundColor: "#FFF3E0",
		textColor: "#E65100",
		borderColor: "#E65100",
	},
	TRA: {
		code: "TRA",
		name: "Training",
		backgroundColor: "#EDE7F6",
		textColor: "#000000DE",
		borderColor: "#EDE7F6",
	},
	COF: {
		code: "COF",
		name: "Time Off",
		backgroundColor: "#F9DEDC",
		textColor: "#B71C1C",
		borderColor: "#B71C1C",
	},
	RDU: {
		code: "RDU",
		name: "Restricted Duty",
		backgroundColor: "#FFF8E1",
		textColor: "#F57F17",
		borderColor: "#F57F17",
	},
};

export const defaultStatus = {
	code: "SCH",
	name: "Scheduled",
	backgroundColor: "#F9DEDC",
	textColor: "#B71C1C",
	borderColor: "#B71C1C",
};

export const getCapacityText = (job: any) => {
	const { status, value } = job;

	switch (status) {
		// 'OS' / 'US' / 'FS' are logic identifiers; only labels are translated
		case "OS":
			return i18next.t(
				value === 1
					? "full-time-worker-scheduler_workers-surplus_singular"
					: "full-time-worker-scheduler_workers-surplus",
				{ count: value }
			);
		case "US":
			return i18next.t(
				value === 1
					? "full-time-worker-scheduler_workers-required_singular"
					: "full-time-worker-scheduler_workers-required",
				{ count: value }
			);
		case "FS":
			return i18next.t("full-time-worker-scheduler_full-capacity");
		default:
			return "";
	}
};

export const getCapacityColor = (status: string) => {
	const colors = {
		OS: "#757575", // Gray
		US: "#D32F2F", // Red
		FS: "#388E3C", // Green
	};
	return colors[status as keyof typeof colors] || "#757575";
};
